var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4569_10065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10C20.29 10 18.5 11.79 18.5 14C18.5 14.89 18.79 15.71 19.28 16.38C17.33 17.5 16 19.59 16 22C16 24.03 16.94 25.84 18.41 27.03C15.41 28.09 11 32.58 11 40.5H34C34 32.58 29.59 28.09 26.59 27.03C28.06 25.84 29 24.03 29 22C29 19.59 27.67 17.5 25.72 16.38C26.21 15.71 26.5 14.89 26.5 14C26.5 11.79 24.71 10 22.5 10Z",
    fill: "#2F3233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10C20.29 10 18.5 11.79 18.5 14C18.5 14.89 18.79 15.71 19.28 16.38C17.33 17.5 16 19.59 16 22C16 24.03 16.94 25.84 18.41 27.03C15.41 28.09 11 32.58 11 40.5H34C34 32.58 29.59 28.09 26.59 27.03C28.06 25.84 29 24.03 29 22C29 19.59 27.67 17.5 25.72 16.38C26.21 15.71 26.5 14.89 26.5 14C26.5 11.79 24.71 10 22.5 10Z",
    stroke: "#2F3233",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9C20.29 9 18.5 10.79 18.5 13C18.5 13.89 18.79 14.71 19.28 15.38C17.33 16.5 16 18.59 16 21C16 23.03 16.94 24.84 18.41 26.03C15.41 27.09 11 31.58 11 39.5H34C34 31.58 29.59 27.09 26.59 26.03C28.06 24.84 29 23.03 29 21C29 18.59 27.67 16.5 25.72 15.38C26.21 14.71 26.5 13.89 26.5 13C26.5 10.79 24.71 9 22.5 9Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4569_10065",
    x: 9.25,
    y: 9.25,
    width: 26.5,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4569_10065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4569_10065",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWp);
export default __webpack_public_path__ + "static/media/wp.ec58fed421dd42159583849743bbd904.svg";
export { ForwardRef as ReactComponent };